import React from 'react';
import Contact from '../components/Contact';

const ContactPage: React.FC = () => <Contact lead />;

export default ContactPage;
